/* eslint-disable import/prefer-default-export */
import { fancyWarning } from "~utils/helpers";
import { getPriceByCurrency } from "~utils/shopify";
import {decodeStorefrontId} from "./shopify";

export function pushProductEvent(
  product,
  currencyCode = `USD`,
  event,
  quantity = 1
) {
  if (
    typeof window === `undefined` ||
    !window ||
    !product?.variant?.sku ||
    !product?.variant?.title
  ) {
    return;
  }

  let location = `love-money-store`;

  if (process.env.GATSBY_SHOPIFY_STORE) {
    location = process.env.GATSBY_SHOPIFY_STORE;
  }

  const ecommerce = {
    currencyCode
  };

  const products = [
    {
      id: product.variant.sku,
      name: product.title,
      price: product.variant.price,
      quantity,
      variant: product.variant.title
    }
  ];

  switch (event) {
    case `addToCart`:
      ecommerce.add = {
        location,
        products
      };

      break;

    case `productView`:
      ecommerce.detail = {
        location,
        products
      };

      break;

    case `removeFromCart`:
      ecommerce.remove = {
        location,
        products
      };

      break;

    default:
      break;
  }

  const eventData = {
    event,
    ecommerce
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventData);
}

export function gtagTrackProductView(product, variant) {
  if (
    process.env.NODE_ENV !== `production` ||
    typeof window === `undefined` ||
    !window?.gtag ||
    !product
  ) {
    fancyWarning(`[GTAG] debug track product`);
    return;
  }

  const data = {
    id: decodeStorefrontId(product.id, `Product`),
    name: product.title,
    brand: product.vendor,
    category: product.productType,
    variant: variant.title,
    price: variant.price
  };

  window.gtag(`event`, `view_item`, {
    items: [data]
  });
}

export function gtagTrackAddToCart(productWithVariant, quantity = 1) {
  if (
    process.env.NODE_ENV !== `production` ||
    typeof window === `undefined` ||
    !window?.gtag ||
    !productWithVariant?.variant
  ) {
    fancyWarning(`[GTAG] debug track add to cart`);
    return;
  }

  const data = {
    id: decodeStorefrontId(productWithVariant.variant.id, `ProductVariant`),
    name: productWithVariant.title,
    brand: productWithVariant.vendor,
    category: productWithVariant.productType,
    variant: productWithVariant.variant.title,
    quantity,
    price: productWithVariant.variant.price
  };

  window.gtag(`event`, `add_to_cart`, {
    items: [data]
  });
}

function generateFbqEventId() {
  return Date.now().toString() + Math.random();
}

export function fbqTrackCheckout(cart, products, currency) {
  if (
    process.env.NODE_ENV !== `production` ||
    typeof window === `undefined` ||
    !window?.fbq ||
    !cart?.[0]
  ) {
    fancyWarning(`fbq:warn | Required variable(s) undefined`);
    return;
  }

  const cartIds = [];
  let cartTotal = 0;

  cart.forEach(cartItem => {
    products.forEach(productItem => {
      productItem.variants.forEach(productItemVariant => {
        if (productItemVariant.id === cartItem.variantId) {
          cartIds.push(cartItem.variantId);
          cartTotal +=
            getPriceByCurrency(productItemVariant, currency) *
            cartItem.quantity;
        }
      });
    });
  });

  const fbqData = {
    content_name: `Checkout`,
    content_category: `snippets`,
    content_ids: cartIds,
    value: cartTotal,
    currency
  };

  console.log(`fbq:key  | `, `InitiateCheckout`);
  console.log(`fbq:data |  `, fbqData);

  window.fbq(`track`, `InitiateCheckout`, fbqData);
}

export function fbqTrackProductGroup(key, product, variant, currency) {
  if (
    process.env.NODE_ENV !== `production` ||
    typeof window === `undefined` ||
    !window?.fbq ||
    !product ||
    !variant
  ) {
    fancyWarning(`fbq:warn | Required variable(s) undefined`);
    return;
  }

  const fbqData = {
    content_name: `${product.title} ${variant.title}`,
    content_category: product.productType,
    content_ids: [decodeStorefrontId(product.id, `Product`)],
    content_type: `product_group`,
    value: variant.price,
    currency
  };

  console.log(`fbq:key  | `, key);
  console.log(`fbq:data | `, fbqData);

  window.fbq(`track`, key, fbqData, { eventID: generateFbqEventId() });
}

export function fbqTrackProduct(key, productWithVariant, currency) {
  if (
    process.env.NODE_ENV !== `production` ||
    typeof window === `undefined` ||
    !window?.fbq ||
    !productWithVariant?.variant
  ) {
    fancyWarning(`fbq:warn | Required variable(s) undefined`);
    return;
  }

  const fbqData = {
    content_name: `${productWithVariant.title} ${productWithVariant.variant.title}`,
    content_category: productWithVariant.productType,
    content_ids: [
      decodeStorefrontId(productWithVariant.variant.id, `ProductVariant`)
    ],
    content_type: `product`,
    value: productWithVariant.variant.price,
    currency
  };

  console.log(`fbq:key  | `, key);
  console.log(`fbq:data | `, fbqData);

  window.fbq(`track`, key, fbqData, { eventID: generateFbqEventId() });
}
